export interface ColabfoldJob {
    id: string;
    jobname: string;
    status: string;
    created_at: string;
    updated_at: string;
    error_message?: string;
    query_sequence: string;
    num_relax: number;
    template_mode: string;
    folder?: string | null;
    quality_metrics?: {
        files?: string[];
        scores?: {
            plddt?: number[];
        };
        ranked_model?: string;
    };
    aws_resources?: {
        [key: string]: string | number | boolean | null | undefined;
    };
}

export enum ModelType {
    COLABFOLD = 'colabfold',
    RFDIFFUSION = 'rfdiffusion',
    ESMIF = 'esmif',
    PROTEINOPT = 'proteinopt'
}

export interface ColabfoldParams {
    jobname: string;
    query_sequence: string;
    template_mode: 'none' | 'pdb100' | 'custom';
    num_recycles: number;
    max_recycles: number;
    num_relax: number;
    msa_mode: 'single_sequence' | 'mmseqs2_uniref_env' | 'mmseqs2_uniref';
    pair_mode: 'unpaired' | 'paired';
    rank_by: 'plddt' | 'ptm';
    stop_at_score: number;
    num_models: number;
    folder?: string | null;
}

export interface RFDiffusionParams {
    jobname: string;
    query_sequence: string;
    sequence: string;
    num_designs: number;
    num_diffusion_steps: number;
    noise_scale: number;
    motif_scaffold: string;
    symmetry: {
        type?: 'cyclic' | 'dihedral' | 'tetrahedral';
        order?: number;
    };
    symmetric_handling: string;
    contigs: string;
    length: number;
    temperature: number;
    seed: number;
    input_pdb?: string;
    binder_design?: boolean;
    hotspots?: string;
    model_type?: 'default' | 'beta';
    design_mode?: 'general' | 'binder' | 'scaffold';
    binding_pocket?: {
        chain: string;
        start: number;
        end: number;
    };
    binder_length_min?: number;
    binder_length_max?: number;
    use_multimer?: boolean;
    folder?: string | null;
}

export interface ESMIFParams {
    jobname: string;
    input_pdb: string;
    num_designs: number;
    temperature: number;
    folder?: string | null;
}

export type ModelParams = ColabfoldParams | RFDiffusionParams | ESMIFParams;

export interface JobFormData {
    model_type: ModelType;
    params: ModelParams;
}

export interface ColabfoldResult {
  modelQualityPlot: string; // URL to the plot image
  modelStructure: string;   // URL to the structure file
  logs: string[];          // Array of log messages
} 